import { KkmRetailPlaceInfo } from './kkm-retail-place-info.types';

export const KKM_RETAIL_PLACE_INFO: KkmRetailPlaceInfo[] = [
  {
    title: 'kkm.settings.in.retail.place',
    property: 'title',
  },
  {
    title: 'kkm.settings.retail.place.address',
    property: 'address',
  },
];
